import './index.css';

import { initYouTubeBackground } from '@/utils/youtube-bg.js';
document.addEventListener('DOMContentLoaded', initYouTubeBackground);
